import { defineStore } from "pinia";
import { useMultiAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationAnimalWelfareTags = defineStore("curation-distribution-tags-animal-welfare-field", () => {
  const field = useMultiAdditionalServiceField({
    id: "animal_welfare_tags",
    functionalGroupCode: "ANIMAL_WELFARE_TAGS",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("animal_welfare_tags");

  return { ...field, hasUnpublishedChange };
});
